/*
 * @Author: Han
 * @Date: 2022-05-10 16:12:23
 * @LastEditors: Han
 * @LastEditTime: 2022-05-10 16:51:57
 * @FilePath: \czssj-h5\h5\src\router\index.js
 */
import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import('@/views/home/Home')
const ClassSituation = () => import('@/views/classSituation/classSituation')
const GrowthPoints = () => import('@/views/growthPoints/growthPoints')
const StudentCertificate = () => import('@/views/studentCertificate/studentCertificate')
const ocrStudentHomeworkDetail = () => import('@/views/ocrStudentHomeworkDetail/ocrStudentHomeworkDetail')
const perfectRegis = () => import('@/views/perfectRegis/perfectRegis')
const CampActivities = () => import('@/views/campActivities/campActivities')


Vue.use(Router)
export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      redirect: '/home',
    },
    {
      path: '/home',
      name: '首页',
      component: Home,
      meta: {
        title: '初中生世界数学思维营活动'
      },
      children: []
    },
    {
      path: '/classSituation',
      name: '班级情况',
      component: ClassSituation,
      children: []
    },
    {
      path: '/growthPoints',
      name: '成长积分',
      component: GrowthPoints,
      children: []
    },
    {
      path: '/certificate',
      name: '我的证书',
      component: StudentCertificate,
      children: []
    },
    {
      path: '/campActivities',
      name: '初中生世界数学思维营活动',
      component: CampActivities,
      children: []
    },
    {
      path: '/homeworkOcrDetail/:id',
      name: '批改结果',
      component: ocrStudentHomeworkDetail,
      children: []
    }, {
      path: '/perfectRegis/:key',
      name: '完善资料',
      component: perfectRegis,
      children: [] 
    }
    
  ]  
})



// WEBPACK FOOTER //
// ./src/router/index.js